import { request } from "@/plugins/axios";
import qs from 'qs';

//账户管理 ------接口


//获取用户信息
export async function getuserInfo() {
    return await request({
        url: '/api/u_i/userInfo',
        method: 'post',
    })
}
//设置用户头像
export async function setUserImg(params) {
    return await request({
        url: '/api/a_u/set_head',
        method: 'post',
        data:qs.stringify(params)
    })
}

//修改用户昵称
export async function setNick(params) {
    return await request({
        url: '/api/a_u/set_nick',
        method: 'post',
        data:qs.stringify(params)
    })
}

//修改手机号码
export async function setPhone(params) {
    return await request({
        url: '/api/a_u/set_phone',
        method: 'post',
        data:qs.stringify(params)
    })
}
//修改用户邮箱
export async function setEmail(params) {
    return await request({
        url: '/api/a_u/set_email',
        method: 'post',
        data:qs.stringify(params)
    })
}
//通过邮箱获取验证码
export async function getCodeByEmail(params) {
    return await request({
        url: '/api/u_m/mailbox',
        method: 'post',
        data:qs.stringify(params)
    })
}
//修改密码
export async function cypherPW(params) {
    return await request({
        url: '/api/u_r/cypher',
        method: 'post',
        data:qs.stringify(params)
    })
}


//设置个人信息
export async function setUserInfo(params) {
    return await request({
        url: '/api/a_u/set_user_info',
        method: 'post',
        data:qs.stringify(params)
    })
}
//添加地址
export async function enterpriseInfo(params) {
    return await request({
        url: '/api/a_u/addr',
        method: 'post',
        data:params
    })
}
//获取工厂地址簿列表
export async function companyList(params) {
    return await request({
        url: '/api/a_u/company_list',
        method: 'post',
        data:qs.stringify(params)
    })
}
//删除工厂
export async function delCompany(params) {
    return await request({
        url: '/api/a_u/del_company',
        method: 'post',
        data:qs.stringify(params)
    })
}
//编辑工厂中的保存
export async function editCompany(params) {
    return await request({
        url: '/api/a_u/edit_company',
        method: 'post',
        data:qs.stringify(params)
    })
}
// 获取企业信息
export async function get_company_info(params) {
    return await request({
        url: '/api/a_u/get_company_info',
        method: 'post',
        data:qs.stringify(params)
    })
}
// 保存企业信息
export async function companyInfo(params) {
    return await request({
        url: '/api/a_u/company_info',
        method: 'post',
        data:qs.stringify(params)
    })
}

// 删除账户
export async function del_accont() {
    return await request({
        url: '/api/a_u/del_accont',
        method: 'get',
        params:{}
    })
}
